import { get } from '@rails/request.js'

export default class AnsweringServiceController {
    static panzoomUserPhoto = null;
    static panzoomIdPhoto = null;
    static panzoomAnotherPhoto = null;

    constructor() {
        $(document).on('change', '#trouble_ticket_card_model_id', function () {
            let trouble_ticket_card_number = $("#trouble_ticket_card_number")
            let url = $(this).data('url')
            trouble_ticket_card_number.val(trouble_ticket_card_number.val().trim())
            get(url, {
                query: {
                    card_number: trouble_ticket_card_number.val(),
                    card_model: $(this).val()
                },
                responseKind: 'turbo-stream'
            })
        })
        $(document).on('focusout', '#trouble_ticket_card_number', function () {
            let trouble_ticket_card_number = $(this)
            let url = $(this).data('url')
            trouble_ticket_card_number.val(trouble_ticket_card_number.val().trim())
            get(url, {
                query: {
                    card_number: trouble_ticket_card_number.val(),
                    card_model: $("#trouble_ticket_card_model_id").val()
                },
                responseKind: 'turbo-stream'
            })
        })
        $(document).on('search', '#person_lookup', function (e) {
            if (!e.target.value) {
                document.getElementById(e.target.getAttribute('form')).requestSubmit()
            }
        })
        $(document).on('change', '#trouble_ticket_card_id', function () {
            let trouble_ticket_card_id = $(this)
            let url = $(this).data('url')
            get(url, {
                query: {
                    card_id: trouble_ticket_card_id.val()
                },
                responseKind: 'turbo-stream'
            })
        })
    }

    static makeIdZoomable(image) {
        this.panzoomIdPhoto = this.makeZoomable(this.panzoomIdPhoto, image)
    }

    static makePersonZoomable(image) {
        this.panzoomUserPhoto = this.makeZoomable(this.panzoomUserPhoto, image)
    }

    static makeAnotherZoomable(image) {
        this.panzoomAnotherPhoto = this.makeZoomable(this.panzoomAnotherPhoto, image)
    }

    static zoomIn(identifier) {
        if (identifier === "person") {
            AnsweringServiceController.panzoomUserPhoto.smoothZoom(180, 180, 1.25);
        } else if (identifier === "ID") {
            AnsweringServiceController.panzoomIdPhoto.smoothZoom(180, 180, 1.25);
        } else {
            AnsweringServiceController.panzoomAnotherPhoto.smoothZoom(180, 180, 1.25);
        }
    }

    static zoomOut(identifier) {
        if (identifier === "person") {
            AnsweringServiceController.panzoomUserPhoto.smoothZoom(180, 180, 0.8);
        } else if (identifier === "ID") {
            AnsweringServiceController.panzoomIdPhoto.smoothZoom(180, 180, 0.8);
        } else {
            AnsweringServiceController.panzoomAnotherPhoto.smoothZoom(180, 180, 0.8);
        }
    }

    static makeZoomable(pzInstance, image) {
        if (pzInstance) return;

        pzInstance = panzoom(image, {
            smoothScroll: false,
            maxZoom: 4,
            minZoom: 0.5,
            zoomDoubleClickSpeed: 1,
            bounds: true,
            boundsPadding: 0.2
        });
        return pzInstance
    }
}
